import { Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { DataService } from '../data.service';

@Component({
  selector: 'app-encuestas',
  templateUrl: './encuestas.component.html',
  styleUrls: ['./encuestas.component.css']
})
export class EncuestasComponent {
  encuestas;
  hayEncuestas: boolean = true;
  editarEncuesta: boolean = false;
  idEncuesta: string;
  Encuesta: any;
  crearencuesta: boolean = false;
  @Output() verResultados = new EventEmitter<string>();
  @Output() encuestaCreada = new EventEmitter<void>();


  constructor(public data: DataService, private route: ActivatedRoute, private router: Router) {

    this.ObtenerEncuestas();

  }

  ObtenerEncuestas() {
    this.data.ObtenerEncuestas(this.route.snapshot.paramMap.get('id')).subscribe(
      {
        next: (x) => 
          {      
            this.encuestas = x;
            console.log("================ENCUESTAS RECIBIDAS================");
            console.log(x);
          },
          error: (error) => {
          //si error es 404, no hay encuestas 
          if (error.status === 404) {
            console.log('No hay encuestas');
            this.hayEncuestas = false;
          }
          else
          {
            console.error('Error al listar encuestas:', error);
            console.log(error);
          }
        }
      });
  }

  navigateToEncuesta(id: string) {
    console.log('navegando a encuesta:', id);

    //this.router.navigate(['/encuesta', id]);
    this.editarEncuesta = true;
    this.idEncuesta = id;
    this.Encuesta = this.encuestas.find(x => x._id === id);
    console.log('Encuesta:');
    console.log(this.Encuesta);
  }

  navigateToResultados(idencuesta: string) {
    console.log('navegando a Resultados encuesta:', idencuesta);
    console.log('Encuesta:');
    console.log(idencuesta);
    const id = this.route.snapshot.paramMap.get('id');
    // navegar y recargar pagina a '/formulario', id, idencuesta 
    this.idEncuesta = idencuesta;

    //this.router.navigate(['/formulario', id, idencuesta]);

    this.verResultados.emit(idencuesta);
  }

  onEdicionFinalizada() {
    this.editarEncuesta = false; // Oculta el componente de edición
    this.idEncuesta = null;
    this.ObtenerEncuestas();
  }

  onCreacionFinalizada() {
    this.crearencuesta = false; // Oculta el componente de creación
    this.encuestaCreada.emit();
    this.ObtenerEncuestas();
  }

  onCrearEncuesta() {
    this.crearencuesta = true;
  }
}